import { ClientInferResponseBody } from "@ts-rest/core";

import { api, contract } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";

export type RemoveOptimizationLineDto = ClientInferResponseBody<
  typeof contract.optimizations.removeLine
>;

export const removeOptimizationLine = async ({
  optimizationId,
  lineId,
}: {
  optimizationId: string;
  lineId: string;
}): Promise<RemoveOptimizationLineDto> => {
  const response = await api.optimizations.removeLine.mutation({
    params: { id: optimizationId, lineId },
  });

  if (response.status !== 200) {
    throw new ApiError("Error removing optimization line", response.status, response.body);
  }

  return response.body;
};
